import {Maybe} from '@/graphql/types';
import useIdentity from '@/hooks/useIdentity';

type CorporateAccountInfo = {
  isSingleCorporate: boolean;
  hasMultipleAccounts: boolean;
  corporateAccountId: string | undefined;
  corporateDisplayName: string | undefined;
  corporateAccountsCount: number;
  corporateLogoIconUrl?: Maybe<string>;
};

export default function useCorporateAccount(): CorporateAccountInfo {
  const {data} = useIdentity();

  const corporateAccount = data?.me?.consumerAccount?.corporateAccount;
  const corporateAccountId = corporateAccount?.id;
  const corporateAccounts = data?.me?.consumerAccount?.corporateAccounts ?? [];
  const corporateAccountsCount = corporateAccounts?.length ?? 0;
  const isSingleCorporate =
    !!corporateAccount && (!corporateAccounts || corporateAccounts.length <= 1);
  const hasMultipleAccounts = corporateAccountsCount > 1;

  const corporateDisplayName = corporateAccount?.displayName ?? corporateAccount?.name;

  const corporateLogoIconUrl = corporateAccount?.logoIconUrl;

  return {
    isSingleCorporate,
    hasMultipleAccounts,
    corporateAccountId,
    corporateAccountsCount,
    corporateDisplayName,
    corporateLogoIconUrl,
  };
}
